module.exports = __webpack_public_path__ + "img/kuwait-1.c14a3b9c.jpg";